module.exports = __webpack_public_path__ + "img/map.ce971ec9.jpeg";